
import { featuredProducts } from '../../../mocks/products';

export default function FeaturedProducts() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Ofertas Destacadas del Mes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Productos en existencias con precios especiales. ¡Aprovecha estas ofertas limitadas!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {featuredProducts.map((product) => (
            <div 
              key={product.id} 
              className={`bg-white rounded-lg shadow-md hover:shadow-xl transition-all overflow-hidden group ${product.highlight ? 'ring-2 ring-teal-500' : ''}`}
            >
              {product.highlight && (
                <div className="bg-teal-500 text-white text-center py-2 font-semibold text-sm">
                  🔥 OFERTA DESTACADA - Unidad: {product.price}€
                </div>
              )}
              
              <div className="relative overflow-hidden" style={{ width: '100%', height: '300px' }}>
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{product.name}</h3>
                <p className="text-gray-600 text-sm mb-4">{product.description}</p>
                
                <div className="mb-4">
                  <p className="text-sm text-gray-700 font-medium mb-2">Colores disponibles:</p>
                  <div className="flex flex-wrap gap-2">
                    {product.colors.map((color, idx) => (
                      <span key={idx} className="text-xs bg-gray-100 px-3 py-1 rounded-full text-gray-700">
                        {color}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="mb-4">
                  <p className="text-sm text-gray-700 font-medium mb-2">Tallas disponibles:</p>
                  <div className="flex gap-2">
                    {product.sizes.map((size, idx) => (
                      <span key={idx} className="text-xs bg-gray-100 px-3 py-1 rounded-md text-gray-700 font-medium">
                        {size}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between mb-4">
                  <div>
                    <span className="text-2xl font-bold text-teal-600">{product.price}€</span>
                    <span className="text-sm text-gray-500 ml-2">/ unidad</span>
                  </div>
                  <span className="text-sm text-gray-500">Stock: {product.stock}</span>
                </div>

                <a 
                  href={`/product-detail?id=${product.id}`}
                  className="block w-full bg-teal-500 hover:bg-teal-600 text-white text-center py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Ver Detalles
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="/catalog" 
            className="inline-block bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            Ver Catálogo Completo
          </a>
        </div>

        {/* Size Guide Info */}
        <div className="mt-16 bg-gray-50 rounded-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">Guía de Tallas</h3>
          <div className="overflow-x-auto">
            <table className="w-full max-w-3xl mx-auto">
              <thead>
                <tr className="border-b-2 border-gray-300">
                  <th className="py-3 px-4 text-left font-semibold text-gray-900">Talla</th>
                  <th className="py-3 px-4 text-left font-semibold text-gray-900">Pecho</th>
                  <th className="py-3 px-4 text-left font-semibold text-gray-900">Cintura</th>
                  <th className="py-3 px-4 text-left font-semibold text-gray-900">Cadera</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-gray-200">
                  <td className="py-3 px-4 font-medium">S</td>
                  <td className="py-3 px-4">88-92 cm</td>
                  <td className="py-3 px-4">76-80 cm</td>
                  <td className="py-3 px-4">92-96 cm</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-3 px-4 font-medium">M</td>
                  <td className="py-3 px-4">96-100 cm</td>
                  <td className="py-3 px-4">84-88 cm</td>
                  <td className="py-3 px-4">100-104 cm</td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-3 px-4 font-medium">L</td>
                  <td className="py-3 px-4">104-108 cm</td>
                  <td className="py-3 px-4">92-96 cm</td>
                  <td className="py-3 px-4">108-112 cm</td>
                </tr>
                <tr>
                  <td className="py-3 px-4 font-medium">XL</td>
                  <td className="py-3 px-4">112-116 cm</td>
                  <td className="py-3 px-4">100-104 cm</td>
                  <td className="py-3 px-4">116-120 cm</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-center text-sm text-gray-600 mt-4">
            * Las medidas pueden variar ligeramente según el modelo. Consulta para más información.
          </p>
        </div>
      </div>
    </section>
  );
}
